export default __webpack_public_path__ + "static/media/place_holder_campaign.1c6b18cf.svg";